import { STXAxiosInstance } from '../Axios/STXAxiosInstance';
import { stxToApiNetwork } from '../Axios/utils';
import { ContactsResponse, IAddContact } from '../types/api/ApiResponseTypes';
import { NETWORK } from '../types/enums';

export const getAllMyContacts = async () => {
  const network = stxToApiNetwork((localStorage.getItem('network') || 'mainnet') as NETWORK);

  return STXAxiosInstance.get<ContactsResponse>(`/contacts?network=${network}`, {}).then(
    (data) => data.data
  );
};

export const deleteContact = async (id: string) => {
  return STXAxiosInstance.delete<void>(`/contacts/${id}`, {});
};

export const addContact = async (contact_name: string, contact_address: string) => {
  const network = stxToApiNetwork((localStorage.getItem('network') || 'mainnet') as NETWORK);

  return STXAxiosInstance.post<IAddContact>(`/contacts`, {
    contact_name,
    contact_address,
    network,
  }).then((data) => data.data);
};

export const editContact = async (contact_name: string, contact_address: string, _id: string) => {
  const network = stxToApiNetwork((localStorage.getItem('network') || 'mainnet') as NETWORK);

  return STXAxiosInstance.put<IAddContact>(`/contacts`, {
    contact_name,
    contact_address,
    _id,
    network,
  }).then((data) => data.data);
};
